import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router';
import type { FunctionComponent } from 'react';
import { AppShell } from '@/components/shell/AppShell';
import { AdsPage } from '@/features/ads/AdsPage';
import { AlertsPage } from '@/features/alerts/AlertsPage';
import { AttributionPage } from '@/features/attribution/AttributionPage';
import { AvailabilityPage } from '@/features/booking-admin/AvailabilityPage';
import { BookingQueuePage } from '@/features/booking-admin/BookingQueuePage';
import { KalenderPage } from '@/features/booking-funnel/KalenderPage';
import { FunnelPage } from '@/features/funnel/FunnelPage';
import { InnholdPage } from '@/features/innhold/InnholdPage';
import { KartPage } from '@/features/kart/KartPage';
import { LandingPage } from '@/features/landing/LandingPage';
import { LeadsPage } from '@/features/leads/LeadsPage';
import { MetaAccountPage } from '@/features/meta/MetaAccountPage';
import { MetaDoorsPage } from '@/features/meta/MetaDoorsPage';
import { MetaCustomersPage } from '@/features/meta/MetaCustomersPage';
import { MetaHistoryPage } from '@/features/meta/MetaHistoryPage';
import { MetaProductionPage } from '@/features/meta/MetaProductionPage';
import { MetaSystemPage } from '@/features/meta/MetaSystemPage';
import { OverviewPage } from '@/features/overview/OverviewPage';
import { PlanPage } from '@/features/plan/PlanPage';
import { ProfitabilityPage } from '@/features/profitability/ProfitabilityPage';
import { QuizPage } from '@/features/quiz/QuizPage';
import { RulesPage } from '@/features/rules/RulesPage';
import { SannhetenPage } from '@/features/sannheten/SannhetenPage';
import { TargetsPage } from '@/features/targets/TargetsPage';
import { TrendsPage } from '@/features/trends/TrendsPage';
import { VervingPage } from '@/features/verving/VervingPage';

// Code-based routing (see vite.config.ts). The shell is the root layout.
const rootRoute = createRootRoute({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});

const route = (path: string, component: FunctionComponent) =>
  createRoute({ getParentRoute: () => rootRoute, path, component });

const routeTree = rootRoute.addChildren([
  route('/', OverviewPage),
  route('/funnel', FunnelPage),
  route('/trends', TrendsPage),
  route('/ads', AdsPage),
  route('/landing', LandingPage),
  route('/attribution', AttributionPage),
  route('/quiz', QuizPage),
  route('/kalender', KalenderPage),
  route('/leads', LeadsPage),
  route('/sannheten', SannhetenPage),
  route('/verving', VervingPage),
  route('/kart', KartPage),
  route('/innhold', InnholdPage),
  route('/meta', MetaAccountPage),
  route('/meta/produksjon', MetaProductionPage),
  route('/meta/system', MetaSystemPage),
  route('/meta/dorer', MetaDoorsPage),
  route('/meta/historikk', MetaHistoryPage),
  route('/meta/kunder', MetaCustomersPage),
  route('/alerts', AlertsPage),
  route('/plan', PlanPage),
  route('/lonnsomhet', ProfitabilityPage),
  route('/targets', TargetsPage),
  route('/rules', RulesPage),
  route('/bookinger', BookingQueuePage),
  route('/tilgjengelighet', AvailabilityPage),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});
